module.exports = __webpack_public_path__ + "img/img2.81516f03.jpg";